module.exports = __webpack_public_path__ + "img/australia-genitourinary-diseases-female.03a38534.png";